import { reviver } from '@thinkalpha/ui-core/serializer';
import { io } from 'socket.io-client';
import type { Socket } from 'socket.io-client';
import { Decoder, Encoder } from 'socket.io-parser';

export interface LocatesSocketConnectionSettings {
    uri: string;
}

export function createLocatesSocket({ uri }: LocatesSocketConnectionSettings): Socket {
    return io(uri, {
        timeout: 10000,
        transports: ['websocket'],
        parser: {
            Encoder: Encoder,
            Decoder: class extends Decoder {
                constructor() {
                    super(reviver);
                }
            },
        },
        reconnectionDelay: 500, // start at half a second
        reconnectionDelayMax: 60000, // one minute for max delay
        randomizationFactor: 0.1, // randomize by 10%
    });
}
